import { EndpointError } from '@square/ignition';
import { Markdown } from '@squareup/dex-ui-markdown';
import { Box, CodeField } from '@squareup/dex-ui-shared-base';
import { breakHtmlForUnderscoreReact } from '@squareup/dex-utils-text';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';

import styles from './error-content.module.css';

interface ErrorContentProps {
  errorProperty: EndpointError;
}

const ErrorContent: FunctionComponent<ErrorContentProps> = ({
  errorProperty,
}) => {
  return (
    <Box className={clsx(styles['error-content'])}>
      <CodeField>{breakHtmlForUnderscoreReact(errorProperty.name)}</CodeField>
      {errorProperty.description && (
        <Markdown
          markdown={errorProperty.description}
          textVariant="20"
        ></Markdown>
      )}
    </Box>
  );
};

export { ErrorContent };
